// liveSnapshots.js
// A Firestore listener hands over its whole result set on every change, though
// almost all of it is unchanged. Turning a document into a plain object
// (`data()`) walks its entire payload — a unit carries its review payload and,
// once ingested, its diffs — so doing that for every document on every change
// costs the size of the whole set each time: a profile of 60 workbooks × 36
// sheets is 1,800 units, each written about 14 times on its way to Completed.
// These helpers convert only what a snapshot changed and keep every other
// object exactly as it was, so a memo or React.memo downstream redoes only the
// work for what changed.

// The snapshot's documents, in the snapshot's order, as `{ id, ...data }` keyed
// by id. A document the snapshot did not change keeps its object from
// `previousById`.
export const mergeSnapshotDocuments = (previousById, snapshot) => {
  const changedById = new Map();
  snapshot.docChanges().forEach((change) => {
    if (change.type === 'removed') return;
    changedById.set(change.doc.id, { id: change.doc.id, ...change.doc.data() });
  });
  return new Map(snapshot.docs.map((document) => [
    document.id,
    changedById.get(document.id) || previousById.get(document.id),
  ]));
};
